<template>
  <b-modal size="xl" button-size="sm" v-model="showModal" :title="title" hide-footer @hidden="cancelar">
    <div class="modal-header justify-content-center" style="padding: 0px">
      <h5 class="text-center" style="padding: 0px">{{ empresaNome }}</h5>
    </div>

    <div class="modal-body">
      <b-card bg-variant="light">
        <b-form @submit.prevent="handleSubmit">
          <b-row class="mb-3">
            <b-col>
              <lg-form-const-select @change="load()" v-model="situacao" id="situacao"
                :options="optionsFilterSituacao" />
            </b-col>
            <b-col>
              <lg-form-input id="searchText" v-model="searchText" />
            </b-col>
            <b-col>
              <b-form-group class="b-form-group-styled d-flex align-items-center">
                <b-button id="localizarEnderecoEletronico" @click="load" class="ml-2" size="sm" pill variant="primary">
                  <div class="btn-size-alinhamento pt-1">
                    <b-icon icon="search" />
                  </div>
                  <b-tooltip target="localizarEnderecoEletronico" title="Localizar" triggers="hover"></b-tooltip>

                </b-button>

                <b-button id="limparEnderecoEletronico" class="ml-2" size="sm" pill variant="primary" @click="limpar">
                  <div class="btn-size-alinhamento pt-1">
                    <b-icon icon="eraser" />
                  </div>
                  <b-tooltip target="limparEnderecoEletronico" title="Limpar" triggers="hover"></b-tooltip>

                </b-button>

                <b-button v-if="temPrivilegioCadastro()" class="ml-2" pill id="addEndereco" variant="primary" size="sm" @click="addEndereco">
                  <div class="btn-size-alinhamento pt-1">
                    <b-icon scale="2" icon="plus" />
                  </div>
                  <b-tooltip target="addEndereco" title="Adicionar novo..." triggers="hover"></b-tooltip>

                </b-button>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
        <b-table :items="this.records" :fields="fields" responsive="sm" striped :hover="true" :busy="this.busy" show-empty>
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>
          <template #empty>
            <p>Nenhum registro encontrado</p>
          </template>

          <template #cell(tipoEnderecoEletronico)="{ item }">
            {{ item.tipoEnderecoEletronico.descricao }}
          </template>
          <template #cell(EnderecoEletronicoDescricao)="{ item }">
            {{ item.descricao }}
          </template>
          <template #cell(acoes)="{ item }">
            <div class="d-flex align-items-center justify-content-end">
              <b-button :disabled="!temPrivilegioEdicao()" id="editar" class="my-2" size="sm" pill variant="primary" @click="ModalEditar(item)">
                <b-icon icon="pencil-square" />
                <b-tooltip target="editar" title="Editar..." triggers="hover"></b-tooltip>
              </b-button>

              <b-button v-if="item.principal" variant="success" class="my-2 mx-2" size="sm"
                :id="'principal-icon-' + item.id">
                <b-icon icon="check-circle" />
                <b-tooltip :target="'principal-icon-' + item.id" title="Endereço Eletrônico Principal"
                  triggers="hover"></b-tooltip>

              </b-button>
              <b-form-checkbox :disabled="!temPrivilegioEdicao()" v-model="item.situacao" class='mx-2' @change="alteraSituacao(item)" name="check-button"
                switch size="lg" :value="1" :unchecked-value="0" :id="'situacao-' + item.id" />
              <b-tooltip :target="'situacao-' + item.id" title="Alterar situação" triggers="hover"></b-tooltip>
            </div>
          </template>
        </b-table>

        <b-row style="margin-top: 12px" v-if="records && records.length > 0">
          <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
            Página {{ page }} de {{ totalPage }} - {{ total }} registros
          </b-col>
          <b-col cols="6">
            <div class="d-flex justify-content-end align-items-end">
              <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page" :per-page="perPage"
                :total-rows="total"></b-pagination>
            </div>
          </b-col>
        </b-row>
        <ModalEnderecoAdicionar v-if="showModalAdicionar" :codEmpresa="codEmpresa" :prefix="updatedPrefix"
          @fechar="fechar" :id="idEdit" />
      </b-card>
    </div>
  </b-modal>
</template>

<script>
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue";
import ResourceService from "@/core/api/ResourceService";
import { ListResourceMixin } from "@/core/mixins/resource";
import ModalEnderecoAdicionar from "@/core/components/Modals/ModalEnderecoEletronicoAdicionar.vue";
import ConfirmMixin from "@/core/mixins/confirm";
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"


export default {
  components: {
    LgFormInput,
    LgFormConstSelect,
    ModalEnderecoAdicionar,
  },
  data() {
    return {
      idEdit: null,
      showModal: true,
      showModalAdicionar: false,
      busy: false,
      situacao: 1,
      searchText: "",
      optionsFilterSituacao: [
        { key: "filterSituacao", text: "Todos", value: undefined },
        { key: "filterSituacao", text: "Ativo", value: 1 },
        { key: "filterSituacao", text: "Inativo", value: 0 },
      ],
      fields: [
        {
          key: "tipoEnderecoEletronico",
          label: "Tipo do Endereço Eletrônico",
          tdClass: "px-3",
        },
        {
          key: "EnderecoEletronicoDescricao",
          label: "Endereço Eletrônico",
          tdClass: "px-3",
        },
        { key: "acoes", label: "" },
      ],
    };
  },
  mixins: [ListResourceMixin, ConfirmMixin],
  beforeMount() {
    this.$service = new ResourceService(`/api/endereco-eletronico`);
  },
  mounted() {
    this.load();
  },
  props: {
    prefix: Array,
    empresaNome: String,
    codEmpresa: Number,
  },
  computed: {
    updatedPrefix() {
      return [...this.prefix, "Endereço Eletronico"];
    },
    title() {
      return this.updatedPrefix.join(" > ");
    },
  },
  watch: {
    page() {
      this.load()
    },
  },

  methods: {
    temPrivilegioCadastro() {
      return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_INCLUIR);

    },
    temPrivilegioEdicao() {
      return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_EDITAR);

    },


    async alteraSituacao(item) {
      let response = await this.$confirm(
        "Deseja " + (item.situacao === 1 ? "ativar" : "desativar") + " o Endereço Eletrônico?",
        item.descricao.toUpperCase()
      )
      if (response == true) {
        this.confirmarAlteracaoSituacao(item)
      } else {
        item.situacao = item.situacao === 1 ? 0 : 1
      }
    },


    async confirmarAlteracaoSituacao(item) {
      const { status } = await this.$service.alteraSituacao(item);
      if (status == 200) {
        this.$notify({
          type: "success",
          message: `Registro ${item.situacao ? "Ativado" : "Desativado"
            } com sucesso!`,
        })
      } else {
        this.$notify({
          type: "danger",
          message: `Erro ao ${item.situacao ? "Ativar" : "Desativar"
            } o registro!`,
        })
      }
    },
    ModalEditar(item) {
      this.idEdit = item.id;
      this.showModalAdicionar = true;
    },
    handleSubmit(event) {
      event.preventDefault();
      this.load();
    },
    closeModal() {
      this.showModal = false;
    },
    async load() {
      this.busy = true;
      var filtro = {};
      if (this.codEmpresa) {
        filtro.codEmpresa = this.codEmpresa;
      }
      if (this.searchText) {
        filtro.pesquisaEndereco = this.searchText;
      }
      if (this.situacao != undefined) {
        filtro.situacao = this.situacao;
      }
      await this.$loadResource({
        limit: this.perPage,
        page: this.page,
        params: filtro,
      });
      this.busy = false;
    },
    addEndereco() {
      this.showModalAdicionar = true;
    },
    limpar() {
      this.situacao = 1;
      this.searchText = "";
      this.load();
    },
    cancelar() {
      this.$emit("close");
    },
    fechar() {
      this.showModalAdicionar = false;
      this.idEdit = null;
      this.load();
    },
  },
};
</script>

<style scoped>
.custom-link {
  color: blue;
  text-decoration: underline;
  text-align: center;
  cursor: pointer;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-body {
  padding-top: 1rem;
}

.table-header {
  margin-bottom: 1rem;
}

.b-table td,
.b-table th {
  vertical-align: middle;
}
</style>
